import * as React from 'react'

import { requestPost, } from '../../../modules/request'
import useSnackbarMonitor from '../../Shared/hooks/useSnackbarMonitor'
import { Snackbar, Tooltip, defaultSnackbarTimeout, } from '../../Shared/index'
import AdminRequestModal from '../components/admin_access/adminRequestModal'
import InviteAdminModal from '../components/admin_access/inviteAdminModal'

const ADMIN_REQUEST_MODAL = 'adminRequestModal'
const INVITE_ADMIN_MODAL = 'inviteAdminModal'

const AdminAccess = ({ school, hasVerifiedEmail, schoolAdmins, hasSchoolPremium, }) => {
  const [modalToShow, setModalToShow] = React.useState(null)
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const [snackbarText, setSnackbarText] = React.useState('');

  useSnackbarMonitor(showSnackbar, setShowSnackbar, defaultSnackbarTimeout)

  function handleEmailVerificationClick() {
    requestPost(`${window.postbuildEnv.DEFAULT_URL}/verify_emails/require_email_verification`, {}, (body) => {
      if (body.redirect) {
        window.location.href = body.redirect
      } else {
        window.location.reload()
      }
    })
  }

  function handleClickRequestToBecomeAdmin() {
    if (schoolAdmins.length) {
      setModalToShow(ADMIN_REQUEST_MODAL)
    } else {
      requestPost(`${window.postbuildEnv.DEFAULT_URL}/admin_access/upgrade_to_admin`, {}, () => {
        window.location.href = '/sign-up/verify-school'
      })
    }
  }

  function handleClickInviteAnAdmin() { setModalToShow(INVITE_ADMIN_MODAL) }

  function onSuccess(snackbarCopy) {
    setModalToShow(null)
    setSnackbarText(snackbarCopy)
    setShowSnackbar(true)
  }

  function closeModal() {
    setModalToShow(null)
  }

  const learnMoreLink = hasSchoolPremium ? <a className="focus-on-light" href="https://support.quill.org/en/articles/1588988-how-do-i-navigate-the-school-dashboard" rel="noopener noreferrer" target="_blank">Learn more about the Premium Hub</a> : <a className="focus-on-light" href="/premium" rel="noopener noreferrer" target="_blank">Learn more about Quill Premium</a>
  const adminParagraph = <p>Admins {hasSchoolPremium ? '' : 'at schools with Quill Premium'} can manage teacher accounts, access teacher reports, and view school-wide student data.</p>
  const emailVerificationParagraph = hasVerifiedEmail ? '' : (
    <section className="email-verification-paragraph">
      <p>You must verify your email to use these features.</p>
      <button className="quill-button outlined medium green focus-on-light" onClick={handleEmailVerificationClick} type="button">Verify your email</button>
    </section>
  )

  let buttonClassName = "quill-button focus-on-light outlined green medium"

  buttonClassName += hasVerifiedEmail ? '' : ' disabled'

  const requestToBecomeAdminButton = <button className={`quill-button focus-on-light contained green medium ${hasVerifiedEmail ? '' : ' disabled'}`} disabled={!hasVerifiedEmail} onClick={handleClickRequestToBecomeAdmin} type="button">Request to become an admin</button>

  let content

  if (schoolAdmins.length) {
    const adminTable = (
      <div className="admin-table">
        <h2>{school.name} admins</h2>
        {schoolAdmins.map(sa => {
          let link = <a className="quill-button outlined green small focus-on-light" href={`mailto:${sa.email}`} rel="noopener noreferrer" target="_blank">Contact</a>
          if (!hasVerifiedEmail) {
            link = (
              <Tooltip
                tooltipText="This action is disabled until your email is verified."
                tooltipTriggerText={<a className="quill-button outlined green small focus-on-light disabled" href={`mailto:${sa.email}`} rel="noopener noreferrer" target="_blank">Contact</a>}
                tooltipTriggerTextClass="disabled-link"
              />
            )
          }
          return (
            <p key={sa.id}><span>{sa.name}</span>{link}</p>
          )
        })}
      </div>
    )
    content = (
      <React.Fragment>
        <div className="text">
          {adminParagraph}
          {learnMoreLink}
        </div>
        {adminTable}
      </React.Fragment>
    )
  } else {
    content = (
      <div className="text">
        <p><span>{school.name}</span> currently has no admins.</p>
        {adminParagraph}
        {learnMoreLink}
      </div>
    )
  }

  return (
    <main className="admin-access-container" id="post-secondary-nav">
      {modalToShow === ADMIN_REQUEST_MODAL && (
        <AdminRequestModal
          closeModal={closeModal}
          onSuccess={onSuccess}
          schoolAdmins={schoolAdmins}
        />
      )}
      {modalToShow === INVITE_ADMIN_MODAL && (
        <InviteAdminModal
          closeModal={closeModal}
          onSuccess={onSuccess}
        />
      )}
      <Snackbar text={snackbarText} visible={showSnackbar} />
      <section className="admin-access">
        <h1>Admin Access</h1>
        <section className="admin-access-content-container">
          {content}
          {emailVerificationParagraph}
        </section>
        <div className="buttons">
          {!schoolAdmins.length && <button className={buttonClassName} disabled={!hasVerifiedEmail} onClick={handleClickInviteAnAdmin} type="button">Invite an admin</button>}
          {requestToBecomeAdminButton}
        </div>
      </section>
    </main>
  )
}

export default AdminAccess
